import {
  ByLocationCard,
  ByLocationCardVariantEnum,
} from '@app/feature/statistics/components/by-location-card/by-location.card';
import { useCpmsBoGetTransactionReportsCountByLocationQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import { useFilters } from '../../context/filters.context';

export const TransactionsByLocationCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetTransactionReportsCountByLocationQuery({
    ...transformedFilters,
  });

  return (
    <ByLocationCard
      data={data}
      variant={ByLocationCardVariantEnum.Transactions}
    />
  );
};
